//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import $ from "jquery";
export default {
  data() {
    return {
      masoGrid: null,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    this.masoGrid = $(".our-values-block-set").masonry({
      itemSelector: ".our-values-block",
      columnWidth: ".our-values-sizer",
      percentPosition: true,
    });

    this.masoGrid.on("click", ".our-values-block-content", (event) => {
      var element = $(event.currentTarget).parent(".our-values-block");
      element.toggleClass("expanded");
      $(".our-values-block")
        .not($(event.currentTarget).parent(".our-values-block"))
        .removeClass("expanded");
      this.masoGrid.masonry();
    });
  },
};
